import { createIntl, createIntlCache } from 'react-intl'
import type { IntlCache, IntlShape } from 'react-intl'

/**
 * Imperative intl singleton, split from the i18n barrel so it can be
 * configured without importing the translation catalogue or moment.
 */
let cache: IntlCache | null
let intl: IntlShape

const generateIntl = (config: Parameters<typeof createIntl>[0]) => {
  if (cache) {
    cache = null
  }
  cache = createIntlCache()
  intl = createIntl(config, cache)
  return intl
}

export { generateIntl, intl }
